import React from 'react';
import './App.css';
import {useAuth} from "./Hooks/useAuth";
import Chat from "./Components/Chat";
import {NonAuth} from "./Components/NonAuth";

interface MessagesInterface {
    id: number,
    sender_id: number,
    recipient_id: number,
    content: string,
    created_at: string,
    updated_at: string,
    is_read: boolean
}
function App() {
    const {isAuth} = useAuth()
    if(!isAuth) return <NonAuth/>
    return <Chat/>
}

export default App;
